"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTrophy = function SvgIconTrophy(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "trophy icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Trophy Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.333 10.483h-7.222V7.68A1.67 1.67 0 0033.444 6H14.556a1.67 1.67 0 00-1.667 1.681v2.802H5.667A1.67 1.67 0 004 12.163v3.923c0 4.658 5.41 9.225 11.938 9.974 2.18 3.65 4.729 5.156 4.729 5.156v5.043h-3.334c-2.451 0-4.444 1.45-4.444 3.922v.84a.84.84 0 00.833.841h20.556a.84.84 0 00.833-.84v-.841c0-2.472-1.993-3.922-4.444-3.922h-3.334v-5.043s2.549-1.506 4.73-5.156C38.61 25.304 44 20.73 44 16.086v-3.922a1.67 1.67 0 00-1.667-1.681zM8.444 16.086v-1.12h4.459c.07 2.283.403 4.286.889 6.037-3.299-1.148-5.348-3.495-5.348-4.917zm31.112 0c0 1.415-2.042 3.769-5.348 4.917.486-1.75.82-3.754.89-6.038h4.458v1.121zm-8.84.33l-2.75 2.703.652 3.824c.118.687-.604 1.205-1.208.883l-3.403-1.807-3.403 1.807c-.61.322-1.326-.203-1.208-.883l.653-3.824-2.75-2.704a.845.845 0 01.465-1.435l3.805-.56 1.702-3.475a.83.83 0 011.493 0l1.701 3.474 3.806.56c.666.106.937.953.444 1.437z"
  }));
};

var _default = SvgIconTrophy;
exports.default = _default;